import { Tab, Tabs } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "../Customize/Customize.module.css";
import LeadManagement from "./LeadManagement/LeadManagement";
import NotificationAutomation from "./Notification/Notification";
import {
  resetDeleteSuccess,
  resetStatusUpdateSuccess,
} from "../../service/LeadAutomationSlice";
import { useDispatch } from "react-redux";

function LeadAutomation(props: any) {
  const {
    getSavedLeadAutomationLoading,
    getSavedLeadAutomationSuccess,
    getSavedLeadAutomationError,
    getSavedLeadAutomationData,
    changeLeadAutomationStatusLoading,
    changeLeadAutomationStatusSuccess,
    changeLeadAutomationStatusError,
    ChangeLeadAutomationStatus,
    GetLeadAutomation,
    DeleteLeadAutomationConfig,
    deleteLeadAutomationConfigSuccess,
  } = props;
  const [savedLeadAutomation, setSavedLeadAutomation] = useState(null);
  const dispatch = useDispatch();

  const instituteFromLocalStorage = JSON.parse(
    localStorage.getItem("ACTIVE_INSTITUTE")!
  );
  const [value, setValue] = useState<number>(0);

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleTabClickQuery = (tabType: any) => {
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set("tabOpen", tabType);
    const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
    window.history.pushState({}, "", newUrl);
  };

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const modalTabOpen = urlSearchParams.get("tabOpen");
    if (instituteFromLocalStorage?.id) {
      if (modalTabOpen) {
        switch (modalTabOpen) {
          case "leadManagement":
            setValue(0);
            break;
          case "notificationAutomation":
            setValue(1);
            break;

          default:
            setValue(0);
            break;
        }
      } else {
        setValue(0);
      }
    }
  }, []);

  useEffect(() => {
    GetLeadAutomation(instituteFromLocalStorage?.id);
  }, []);

  useEffect(() => {
    if (getSavedLeadAutomationData) {
      setSavedLeadAutomation(getSavedLeadAutomationData);
    }
  }, [getSavedLeadAutomationData]);

  useEffect(() => {
    if (
      changeLeadAutomationStatusSuccess === true ||
      deleteLeadAutomationConfigSuccess === true
    ) {
      GetLeadAutomation(instituteFromLocalStorage?.id);
      dispatch(resetStatusUpdateSuccess());
      dispatch(resetDeleteSuccess());
    }
  }, [changeLeadAutomationStatusSuccess, deleteLeadAutomationConfigSuccess]);

  return (
    <div>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="basic tabs example"
        sx={{
          mt: 1,
          mb: 1,
          ml: 4,
          backgroundColor: "white",
          borderBottom: "1px solid #E9E9E9",
          "& .MuiTabs-flexContainer": {
            gap: "24px",
          },
          "& .MuiTabs-indicator": {
            height: "1px",
          },
        }}
      >
        <Tab
          label="Lead Management"
          {...a11yProps(0)}
          onClick={() => {
            handleTabClickQuery("leadManagement");
          }}
          sx={{
            padding: "0",
            textTransform: "capitalize",
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "24px",
            color: "#B4B4B4",
            minWidth: "fit-content",
            "& .Mui-selected": {
              color: "#11C89B",
            },
          }}
        />
        {/* <Tab
          label="Notification"
          {...a11yProps(1)}
          onClick={() => {
            handleTabClickQuery("notificationAutomation");
          }}
          sx={{
            padding: "0",
            textTransform: "capitalize",
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "24px",
            color: "#B4B4B4",
            minWidth: "fit-content",
            "& .Mui-selected": {
              color: "#11C89B",
            },
          }}
        /> */}
      </Tabs>
      <div
        className={styles.customizeTabContentWrap}
        style={{
          maxHeight: "calc(100vh - 180px)",
          minHeight: "calc(100vh - 180px)",
          overflowY: "auto",
        }}
      >
        {value === 0 && (
          <LeadManagement
            savedLeadAutomation={savedLeadAutomation}
            ChangeLeadAutomationStatus={ChangeLeadAutomationStatus}
            getSavedLeadAutomationLoading={getSavedLeadAutomationLoading}
            DeleteLeadAutomationConfig={DeleteLeadAutomationConfig}
          />
        )}
        {value === 1 && <NotificationAutomation />}
      </div>
    </div>
  );
}

export default LeadAutomation;
